// faq toggle
$('.faq-panel__question').click(function(){
    $(this).toggleClass('active').next(".faq-panel__answer").stop().slideToggle(300);
});

$('.faq-panel__answer').click(function(){
    $(this).slideUp().hide(300).siblings(".faq-panel__question").toggleClass('active');
});

// faq scrollspy
let lastId,
    topMenuHeight,
    topMenu = $("#faq-top-menu");
if ($(window).width() < 600) {
    topMenuHeight = topMenu.outerHeight()+16;
} else {
    topMenuHeight = topMenu.outerHeight()+32;
}
let menuItems = topMenu.find("a"),
    scrollItems = menuItems.map(function(){
        let item = $($(this).attr("href"));
        if (item.length) { return item; }
    });

menuItems.click(function(e){
    e.preventDefault();
    let offsetTop,
        href = $(this).attr("href");
    if ($(window).width() < 600) {
        offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+3
    } else {
        offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1
    }
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 300);
});

$(window).scroll(function(){
    let fromTop = $(this).scrollTop()+topMenuHeight;

    let cur = scrollItems.map(function(){
        if ($(this).offset().top < fromTop)
            return this;
    });
    cur = cur[cur.length-1];
    let id = cur && cur.length ? cur[0].id : "";
    if (lastId !== id ) {
        lastId = id;
        menuItems
            .parent().removeClass("active")
            .end().filter("[href='#"+id+"']").parent().addClass("active");
    } else if ( fromTop >= $("#bottom").offset().top ) {
        menuItems
            .parent().removeClass("active")
    }
});
